// Fixed option lists for the sample edit form.
//
// These mirror the hard-coded DropDownList items on the legacy VLP order-entry
// screen (VLP/OrderEntry/OrderEntry.aspx) so Extend offers the same choices for
// the same samples columns. Lists that live in maintenance tables (sample
// types, sample matrices, facility ids, sampling point ids) are fetched at
// runtime instead and are not duplicated here.

// dlPriority -> samples.priority
export const PRIORITY_OPTIONS = ["Regular", "Rush", "Retain"];

// SampleLabList -> samples.OtherLabName. The stored value is the lab's
// certification id; the label is what the lab is called day to day.
export const LAB_OPTIONS = [
  { value: "Madison", label: "Madison" },
  { value: "M-29-01", label: "Carmel" },
  { value: "M-79-02", label: "Lafayette" },
  { value: "C-71-01", label: "Eurofins" },
  { value: "E87605", label: "Pace Florida" },
  { value: "C-MN-01", label: "Pace Minneapolis" },
  { value: "C-49-06", label: "Pace Indy" },
  { value: "P-OH-02", label: "Summit PFAS" },
  { value: "C-KY-02", label: "Pace Madisonville" },
  { value: "C-OH-13", label: "Summit Lab" },
];

// Test processes are shared across validation, billing, import and reporting.
// The sample's Process Id is the validation one (VLP opens the picker with
// OE=0), so the list is filtered down to that type.
export const VALIDATION_PROCESS_TYPE = 0;

// MUI renders a Select blank when its value is not one of its options. Legacy
// samples can hold values that have since been removed from maintenance, so
// keep the current value selectable rather than silently clearing it on save.
export const withCurrentValue = (options, current) => {
  const value = (current ?? "").toString();
  if (!value || options.some((option) => option.value === value)) {
    return options;
  }
  return [...options, { value, label: value }];
};

// Turns a list of maintenance rows into { value, label } option objects.
export const toOptions = (rows, field) =>
  (rows || [])
    .map((row) => (row?.[field] ?? "").toString().trim())
    .filter((value) => value !== "")
    .map((value) => ({ value, label: value }));
